// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notifications_wrapper_BRf9H_B","button":"notifications_button_4ibicXv","counter":"notifications_counter_3a5VsJE"};